import { render, staticRenderFns } from "./RegisterAssets.vue?vue&type=template&id=28d88850&"
import script from "./RegisterAssets.vue?vue&type=script&lang=js&"
export * from "./RegisterAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports